import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import SvgIcon from '../SvgIcon.js';
var IconIcTelegramSquare = props => /*#__PURE__*/
// eslint-disable-next-line react/jsx-props-no-spreading
React.createElement(SvgIcon, _extends({}, props, {
  viewBox: "0 0 40 40",
  iconname: "IconIcTelegramSquare"
}), /*#__PURE__*/React.createElement("rect", {
  width: "40",
  height: "40",
  rx: "4",
  fill: "url(#pathTo_Svg__Paint0_Linear_1_1624)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.05344 19.7889C14.8838 17.2487 18.7717 15.574 20.717 14.7649C26.2712 12.4547 27.4253 12.0534 28.1776 12.0402C28.343 12.0373 28.7129 12.0783 28.9526 12.2727C29.1549 12.4369 29.2106 12.6587 29.2372 12.8143C29.2639 12.97 29.297 13.3246 29.2707 13.6017C28.9697 16.7641 27.6673 24.4386 27.0047 27.9806C26.7244 29.4794 26.1724 29.9819 25.6379 30.0311C24.4765 30.138 23.5946 29.2635 22.4696 28.5261C20.7094 27.3723 19.7149 26.654 18.0063 25.528C16.0317 24.2268 17.3118 23.5116 18.4371 22.3428C18.7316 22.0369 23.8489 17.3823 23.948 16.96C23.9603 16.9072 23.9718 16.7104 23.8549 16.6065C23.738 16.5025 23.5654 16.5381 23.4408 16.5663C23.2643 16.6064 20.4522 18.465 15.0047 22.1423C14.2065 22.6904 13.4835 22.9574 12.8358 22.9434C12.1217 22.928 10.748 22.5397 9.72685 22.2077C8.47435 21.8006 7.47888 21.5853 7.56556 20.8939C7.61071 20.5337 8.10667 20.1654 9.05344 19.7889Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "pathTo_Svg__Paint0_Linear_1_1624",
  x1: "20",
  y1: "0",
  x2: "20",
  y2: "39.7033",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#2AABEE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#229ED9"
}))));
export { IconIcTelegramSquare as default };
//# sourceMappingURL=IconIcTelegramSquare.js.map